import { useEffect, useState } from "react";
import api from "@/lib/api";
import DashboardShell from "@/components/nav/DashboardShell";

export default function Activity() {
  const [items, setItems] = useState([]);
  const [range, setRange] = useState("week");

  useEffect(() => {
    api.get(`/activity?range=${range}&limit=200`).then(({data}) => setItems(data)).catch(() => {});
  }, [range]);

  return (
    <DashboardShell>
      <div className="brand-eyebrow mb-4">FEED</div>
      <h1 className="brand-headline text-4xl md:text-6xl mb-8">Activity.</h1>

      <div className="flex gap-2 mb-8">
        {["today","week","month"].map(r => (
          <button key={r} data-testid={`activity-range-${r}`} onClick={() => setRange(r)}
            className={`text-[10px] tracking-widest font-bold px-3 py-1.5 border ${range===r ? "bg-gold text-ink border-gold" : "text-smoke border-line hover:border-gold"}`}>{r.toUpperCase()}</button>
        ))}
      </div>

      <div className="border-l-2 border-line pl-6 space-y-6">
        {items.length === 0 && <div className="text-smoke text-sm">No activity in this range.</div>}
        {items.map(a => (
          <div key={a.id} className="relative">
            <div className="absolute -left-[29px] top-2 w-3 h-3 bg-ink border-2 border-gold" />
            <div className="text-[10px] tracking-widest text-gold font-bold">{a.event_type}</div>
            <div className="text-white mt-1 font-semibold">{a.title}</div>
            {a.description && <div className="text-smoke text-sm mt-1">{a.description}</div>}
            <div className="text-smoke text-[11px] mt-2">{new Date(a.created_at).toLocaleString()}</div>
          </div>
        ))}
      </div>
    </DashboardShell>
  );
}
